<template>
  <DsShowcase title="TextareaPlayV2" description="Textarea com label, placeholder e estados.">
    <!-- Uso básico -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Uso básico</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>v-model: string</code></p>
      <div class="tw:max-w-lg">
        <TextareaPlayV2 v-model="text1" label="Descrição" placeholder="Escreva uma descrição..." />
      </div>
    </section>

    <!-- Disabled -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">disabled</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code></p>
      <div class="tw:max-w-lg">
        <TextareaPlayV2 model-value="Conteúdo não editável" label="Somente leitura" :disabled="true" />
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import DsShowcase from '../DsShowcase.vue'
import { TextareaPlayV2 } from "@/components/atomic"

const text1 = ref('')
</script>
